import { ServiceFetch } from '../service-fetch'

export default class SaleReturnListModel extends ServiceFetch {
    getSaleReturnListBy = (data) => this.authFetch({
        url: 'sale-return-list/getSaleReturnListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}